import { FormInput, Loader } from "@/components";
import { Button } from "@/components/ui";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui";
import { FormProvider } from "react-hook-form";
import { CONFIRM_PASSWORD, CURRENT_PASSWORD, NEW_PASSWORD } from "./consts";
import useChangePassword from "./useChangePassword";
import logo from "@/assets/ostwal-logo.png";
import { CheckIcon } from "lucide-react";

const ChangePassword = () => {
  const {
    form,
    onSubmit,
    requiredFields,
    onEyeIconClick,
    isPassword,
    Icon,
    isChangePasswordPending,
    showConfirmMsg,
    onOkClick,
  } = useChangePassword();
  const { errors } = form.formState;

  return (
    <div className="w-full h-[100vh] bg-[url('/login-bg.png')] bg-no-repeat bg-cover">
      <div className="grid grid-cols-1 md:grid-cols-2 h-full p-[20px] md:p-[50px] lg:p-[80px]">
        <div className="flex items-center justify-center md:items-start md:justify-start">
          <img src={logo} className="w-[120px]" />
        </div>
        <div className="flex items-center justify-center md:justify-end">
          {showConfirmMsg ? (
            <Card className="w-full lg:w-[400px]">
              <CardHeader className="my-[20px] flex flex-col items-center justify-center">
                <Button className="cursor-default h-[50px] w-[50px]">
                  <CheckIcon className="stroke-3" />
                </Button>
                <CardTitle className="text-center font-[500] text-[24px] ">
                  Email Sent Successfully
                </CardTitle>
                <span className="text-[14px] text-black font-[400]">
                  Login with temporary password
                </span>
              </CardHeader>
              <CardContent></CardContent>
              <CardFooter>
                <Button
                  type="button"
                  className="w-full"
                  disabled={isChangePasswordPending}
                  onClick={onOkClick}
                >
                  Ok
                </Button>
              </CardFooter>
            </Card>
          ) : (
            <FormProvider {...form}>
              <form onSubmit={form.handleSubmit(onSubmit)}>
                <Card className="w-full lg:w-[400px]">
                  <CardHeader className="my-[20px]">
                    <CardTitle className="text-center font-[500] text-[24px]">
                      Reset Password
                    </CardTitle>
                    <span className="text-[14px] text-g-400 text-center">
                      Update your password to ensure account security.
                    </span>
                  </CardHeader>
                  <CardContent>
                    <div className="grid grid-col-1 gap-5">
                      <div>
                        <label className="text-[14px] font-[400]">
                          Old Password
                        </label>
                        <FormInput
                          name={CURRENT_PASSWORD}
                          control={form.control}
                          placeholder="Please enter"
                          error={errors[CURRENT_PASSWORD]?.message}
                          isRequired={requiredFields.includes(CURRENT_PASSWORD)}
                          type={isPassword["current"] ? "password" : "text"}
                          endIcon={
                            <Icon
                              className="h-4 w-4"
                              onClick={onEyeIconClick("current")}
                            />
                          }
                        />
                      </div>
                      <div>
                        <label className="text-[14px] font-[400]">
                          New Password
                        </label>
                        <FormInput
                          name={NEW_PASSWORD}
                          control={form.control}
                          placeholder="Please enter"
                          error={errors[NEW_PASSWORD]?.message}
                          isRequired={requiredFields.includes(NEW_PASSWORD)}
                          type={isPassword["newPassword"] ? "password" : "text"}
                          endIcon={
                            <Icon
                              className="h-4 w-4"
                              onClick={onEyeIconClick("newPassword")}
                            />
                          }
                        />
                      </div>
                      <div>
                        <label className="text-[14px] font-[400]">
                          Confirm Password
                        </label>
                        <FormInput
                          name={CONFIRM_PASSWORD}
                          control={form.control}
                          placeholder="Please enter"
                          error={errors[CONFIRM_PASSWORD]?.message}
                          isRequired={requiredFields.includes(CONFIRM_PASSWORD)}
                          type={isPassword["confirm"] ? "password" : "text"}
                          endIcon={
                            <Icon
                              className="h-4 w-4"
                              onClick={onEyeIconClick("confirm")}
                            />
                          }
                        />
                      </div>
                    </div>
                  </CardContent>
                  <CardFooter>
                    <Button
                      type="submit"
                      className="w-full"
                      disabled={isChangePasswordPending}
                    >
                      {isChangePasswordPending ? (
                        <Loader variant="secondary" />
                      ) : (
                        ""
                      )}{" "}
                      Change Password
                    </Button>
                  </CardFooter>
                </Card>
              </form>
            </FormProvider>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
